import React from "react";
import styled from "styled-components/macro";

const Row = styled.div`
  &:nth-child(odd) {
    background: ${(props) => props.theme.colors.primary};
  }

  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 10px;
  border-radius: 5px;
`;

const Label = styled.div`
  padding-right: 10px;
`;

const Options = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const Option = styled.label`
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  font-size: 12px;
`;

const HiddenRadio = styled.input`
  position: absolute;
  opacity: 0;
  pointer-events: none;
`;

const RadioDot = styled.span`
  width: 15px;
  height: 15px;
  border: 1px solid ${(props) => props.theme.colors.mgrey};
  border-radius: 50%;
  position: relative;

  ${HiddenRadio}:checked + &::after {
    content: "";
    width: 9px;
    height: 9px;
    background: ${(props) => props.theme.colors.red};
    border-radius: 50%;
    position: absolute;
    top: 2px;
    left: 2px;
  }
`;

const BinaryChoiceSelector = ({ id, label, name, value, onChange, yesLabel, noLabel, required }) => {
  const isAnswered =
    value === true ||
    value === false ||
    value === "true" ||
    value === "false" ||
    value === "yes" ||
    value === "no";
  const isYes = value === true || value === "true" || value === "yes";
  const isNo = value === false || value === "false" || value === "no";

  return (
    <Row>
      <Label>{label}</Label>
      <Options>
        <Option htmlFor={`${id}-yes`}>
          <HiddenRadio
            id={`${id}-yes`}
            type="radio"
            name={name}
            value="true"
            required={required && !isAnswered}
            checked={isYes}
            onChange={onChange}
          />
          <RadioDot />
          <span>{yesLabel}</span>
        </Option>
        <Option htmlFor={`${id}-no`}>
          <HiddenRadio
            id={`${id}-no`}
            type="radio"
            name={name}
            value="false"
            required={required && !isAnswered}
            checked={isNo}
            onChange={onChange}
          />
          <RadioDot />
          <span>{noLabel}</span>
        </Option>
      </Options>
    </Row>
  );
};

export default BinaryChoiceSelector;
